import type { ActivityOutcome } from '@/lib/activity-language';
import type { BadgeTone } from '@/components/ui';

/**
 * Tone per outcome — and never tone alone. ONE copy, shared by the audit-log
 * feed (`ApiLogsPage`) and its detail modal (`ApiLogDetailModal`).
 *
 * `outcomeLabel` is rendered as text wherever this tone is, so the feed and the
 * modal survive greyscale, colour blindness and a screen reader intact. The tone
 * is the second signal, not the only one. Typed as a total `Record` on purpose:
 * a new `ActivityOutcome` in the humaniser breaks this build rather than silently
 * rendering as neutral.
 *
 * ⚠️ **Merged 2026-10-11 (UI rework) from two local copies that had DRIFTED**:
 * the modal painted `denied` as danger and `not-found` as warning, while the
 * feed painted them warning and neutral — so one row read differently in the
 * list and in its own detail view. The feed's table was kept.
 */
export const OUTCOME_TONES: Record<ActivityOutcome, BadgeTone> = {
  succeeded: 'success',
  denied: 'warning',
  'not-found': 'neutral',
  invalid: 'warning',
  'rate-limited': 'warning',
  failed: 'danger',
  unauthenticated: 'warning',
};
